import Repository from "../Repository";
import { getAuthHeader } from "../../_helpers/apiHelper";

const resource = "/devicedata";

export default {
  getByCompany(user, companyId, queryParams) {
    var config = {
      headers: getAuthHeader(user),
    };

    return Repository.get(
      `${resource}/company/${companyId}?${queryParams}`,
      config
    );
  },

  getByDevice(user, deviceId, queryParams) {
    var config = {
      headers: getAuthHeader(user),
    };

    return Repository.get(
      `${resource}/device/${deviceId}?${queryParams}`,
      config
    );
  },
};
